import React, { Component } from "react";

class Field extends Component {

	constructor(props) {
		super(props);
		this.eyeIconClass = 'fas fa-eye fa-1x pointer';
		this.hiddenEyeIconClass = 'fas fa-eye-slash fa-1x pointer';
		this.iconPosition = {
			bottom: this.props.iconBottom,
			left: this.props.iconLeft
		};
		this.state = {
			togglePassword: false,
			iconClass: this.props.iconClass
		};
	}

	toggleIcon(isPassword) {
		if (isPassword) return this.eyeIconClass;
		return this.hiddenEyeIconClass;
	}

	render() {
		return (
			<React.Fragment>
				<input
					type={this.state.togglePassword ? 'text' : this.props.type} 
					name={this.props.name} 
					className={this.props.className} 
					placeholder={this.props.placeholder} 
					value={this.props.value}  
					onChange={this.props.onChange}
					minLength={this.props.minlength ? this.props.minlength : 0 }
				/>
				{ this.props.type === "password" && 
					<span className={this.state.iconClass} style={this.iconPosition} onClick={() => {
						this.setState(state => ({
							iconClass: this.toggleIcon(state.togglePassword),
							togglePassword: !state.togglePassword
						}));
					}}></span>
				}
			</React.Fragment>
		);
	}
}

export default Field;
